<template>
  <v-layout>
    <v-row>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.companyName"
            label="Nazwa firmy"
            placeholder=" "
            :counter="100"
            :rules="rules.textFilter"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.nip"
            label="NIP"
            placeholder=" "
            :counter="10"
            :rules="rules.textFilter"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.description"
            label="Opis"
            placeholder=" "
            :counter="100"
            :rules="rules.textFilter"
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.public"
            label="Tylko publiczne"
            hide-details
            @click="onPublicSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko firmy, które zgodziły się na wyświetlanie ich danych w wynikach wyszukiwania.
            </v-tooltip>
          </template>
        </v-checkbox>
        <v-checkbox
            class="mt-3 pt-0"
            v-model="standardFilters.notPublic"
            label="Tylko niepubliczne"
            hide-details
            @click="onNotPublicSwitched"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-help-circle</v-icon>
              </template>
              Tylko firmy, które NIE zgodziły się na wyświetlanie ich danych w wynikach wyszukiwania.
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";

export default {
  data() {
    return {
      filterCompaniesDebouncing: null,
      standardFilters: {
        public: false,
        notPublic: false,
      },
      debouncedFilters: {
        companyName: '',
        nip: '',
        description: '',
      },
      rules: {
        textFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
      },
    };
  },
  created() {
    this.filterCompaniesDebouncing = debounce(function () {
      this.filterCompanies();
    }, 500);
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterCompanies();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filterCompaniesDebouncing();
      },
      deep: true
    },
  },
  methods: {
    filterCompanies() {
      this.$root.$emit('loadPriceListCompanies', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
    onPublicSwitched() {
      if (this.standardFilters.public && this.standardFilters.notPublic) {
        this.standardFilters.notPublic = false
      }
    },
    onNotPublicSwitched() {
      if (this.standardFilters.notPublic && this.standardFilters.public) {
        this.standardFilters.public = false
      }
    },
  }
}
</script>